import React from 'react';

const StoriesIcon = ({ color = '#424242', width = 16, height = 17, ...rest }) => {
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none">
      <path
        d="M3.89613 5.83203C3.89613 3.94641 3.89613 3.0036 4.49694 2.41782C5.09775 1.83203 6.06473 1.83203 7.9987 1.83203C9.93266 1.83203 10.8996 1.83203 11.5005 2.41782C12.1013 3.0036 12.1013 3.94641 12.1013 5.83203V11.1654C12.1013 13.051 12.1013 13.9938 11.5005 14.5796C10.8996 15.1654 9.93266 15.1654 7.9987 15.1654C6.06473 15.1654 5.09775 15.1654 4.49694 14.5796C3.89613 13.9938 3.89613 13.051 3.89613 11.1654V5.83203Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.84485 2.9987C2.12807 2.9987 2.35767 3.22256 2.35767 3.4987V13.4987C2.35767 13.7748 2.12807 13.9987 1.84485 13.9987C1.56163 13.9987 1.33203 13.7748 1.33203 13.4987V3.4987C1.33203 3.22256 1.56163 2.9987 1.84485 2.9987ZM14.1525 2.9987C14.4358 2.9987 14.6654 3.22256 14.6654 3.4987V13.4987C14.6654 13.7748 14.4358 13.9987 14.1525 13.9987C13.8693 13.9987 13.6397 13.7748 13.6397 13.4987V3.4987C13.6397 3.22256 13.8693 2.9987 14.1525 2.9987Z"
        fill={color}
      />
    </svg>
  );
};

export default StoriesIcon;
